<template>
    <div class="contract" v-my-loading='loading'>
        <div class="main" v-if="!loading">
            <!-- 活动未开始 -->
            <div v-if="config.startTime > new Date().getTime()">
                <img class="waitImg" v-if="$route.query.backgroundColor == 'day'" src="../../assets/images/activityWaitIcon.png">
                <img v-else class="waitImg" src="../../assets/images/activityWaitIcon_moon.png">
            </div>

            <!-- 活动已结束 -->
            <div v-else-if="config.endTime < new Date().getTime()">
                <img class="endImg" v-if="$route.query.backgroundColor == 'day'" src="../../assets/images/activityEndIcon.png">
                <img v-else class="endImg" src="../../assets/images/activityEndIcon_moon.png">
            </div>

            <!-- 是否参与过报名 -->
            <div v-else>
                <div v-if="istrue">
                    <img v-if="$route.query.backgroundColor == 'day'" class="sucImg" src="../../assets/images/activityFailIcon.png">
                    <img v-else class="sucImg" src="../../assets/images/activityFailIcon_moon.png">
                </div>
                <div v-else>
                    <img v-if="$route.query.backgroundColor == 'day'" class="sucImg" src="../../assets/images/activitySuccessIcon.png">
                    <img v-else class="sucImg" src="../../assets/images/activitySuccessIcon_moon.png">
                </div>
            </div>
            <span>{{text_variables}}</span>
        </div>
        <img v-if="$route.query.backgroundColor == 'day'" class="bottomBg" src="../../assets/images/bottomBg.png">
        <img v-else class="bottomBg" src="../../assets/images/bottomBg_moon.png">
    </div>
</template>

<script>
    import { findUserOperation, getNewActivity, application } from './api'
    import { mapGetters } from "vuex";
    import { getLanguageList, getUserInfo } from "../../api/user";
    import { setToken } from '../../utils/auth'

    import '@/assets/newCss/reset.scss'
    import '@/assets/tailwendcss.css'
    import '@/assets/uemo-icon-font/fonts/ueicon.css'
    import '@/assets/newCss/var.scss'
    //TODO:行高问题
    import '@/assets/newCss/base.scss'

    export default {
        components: {},
        data() {
            return {
                istrue: '',
                userInfo: {},
                cftj: false,
                loading: true,
                text_variables: '',
                C2CUserInfo: {},
                config: {},
                hasRedirected: false,
                isWebViewVar: '',
            }
        },
        computed: {
            ...mapGetters(['token', 'user', 'language', 'isApp', 'isDirection'])
        },
        async created() {
            this.isWebView()
            if (this.token) {
                await this.getC2CUserInfo()
            }
            this.getGetActivity()
            if (this.$route.query.backgroundColor != '') {
                window.document.documentElement.setAttribute(
                    'data-theme',
                    this.$route.query.backgroundColor === 'day' ? 'sunlight' : 'moon'
                )
            }
            // this.istrue = ''
            let langugage = this.$route.query.language || this.language;
            console.log(this.$route.query.language, 'this.$route.query.language');
            this.$store.dispatch('setLanguage', langugage)
            getLanguageList().then(res => {
                let el = res.data.find(item => {
                    return item.language == this.$route.query.language
                })
                // this.$store.dispatch('setLanguageName', el.name)
                if (this.$route.query.isApp == 1) {
                    this.$i18n.locale = this.$route.query.language
                }
                this.$store.dispatch(
                    "setIsDirection",
                    this.$route.query.language == "fa" || this.language == 'fa' ? true : false
                );
                window.document.documentElement.setAttribute(
                    "dir",
                    this.isDirection ? "rtl" : "ltr"
                );
            })

            // this.resher()
            // console.log(this.isWebViewVar,'看看created里面的');
        },
        mounted() {

        },
        watch: {

            // $route() {
            //   this.resher()
            // },
        },
        methods: {
            // isWebView(){
            //   const ua = navigator.userAgent;
            //   console.log(ua,'ua===ua');
            //   return /(android|iphone|ipad|ipod)/i.test(ua);
            // },

            isWebView() {
                try {
                    this.$jsBridge.callHandler(
                        this.$jsBridgeCmd.isAppWebView,
                        {
                            code: 200,
                            type: 'login',
                        },
                        (data) => {
                            console.log(data, '看看data是什么');
                        },
                        (data) => {
                            console.log(data, '看看data是什么11111112');
                            this.isWebViewVar = 'h5'
                        },
                    )
                } catch (error) {
                    console.log('看看失败的catch');
                }
                // this.$jsBridge.callHandler(
                //         this.$jsBridgeCmd.isAppWebView,
                //         {
                //             code: 200,
                //             type: 'login',
                //         },
                //         (data) => {
                //             console.log(data,'看看data是什么吧');
                //         },
                //     )
            },
            getGetActivity() {
                getNewActivity(this.$route.query.id).then((res) => {
                    if (res.data) {
                        if (res.data.state === 0) {
                            this.$router.replace(`/errorPage?id=${this.$route.query.id}`)
                        } else {
                            this.config = res.data
                            //activity_id 活动id   activity_status:success 报名成功  repeat_join 重复报名 activity_not_begin  activity_end
                            if (this.config.endTime < new Date().getTime()) {
                                // 本次活動已結束，敬請期待下一次活動！ 
                                this.text_variables = this.$t('9100091')
                                posthog.capture('$pageview', {
                                    name: '活动报名状态页面',
                                    pageId: 'activity_join_status_page',
                                    activity_id: this.config.customId,
                                    activity_status: 'activity_end',
                                });
                            } else if (this.config.startTime > new Date().getTime()) {
                                // 活动未开始，敬请期待
                                this.text_variables = this.$t('9100092')
                                posthog.capture('$pageview', {
                                    name: '活动报名状态页面',
                                    pageId: 'activity_join_status_page',
                                    activity_id: this.config.customId,
                                    activity_status: 'activity_not_begin',
                                });
                            } else {
                                if (this.token) {
                                    this.whetherSignUp()
                                } else {
                                    if (this.isWebViewVar == 'h5') {
                                        this.$router.push('/login?historyBack=' + window.encodeURIComponent('/registration?id=' + this.config.customId))
                                    } else {
                                        this.$jsBridge.callHandler(
                                            this.$jsBridgeCmd.appLogin,
                                            {
                                                code: 200,
                                                type: 'login',
                                            },
                                            (data) => { }
                                        )
                                    }
                                }
                            }
                            setTimeout(() => {
                                this.loading = false
                            }, 3000)
                        }
                    } else {
                        this.$router.replace(`/errorPage?id=${this.$route.query.id}`)
                    }
                })
            },
            // resher(){
            //   this.isApp = this.$route.query.isApp
            //   let token = this.$route.query.token || this.token
            //   if (token) {
            //     setToken(token);
            //     this.$store.dispatch('GetInfo', token);
            //     this.$store.dispatch('setToken', token);
            //     // if (this.$route.query.isApp == 1) {
            //       getUserInfo(token).then(res => {
            //         this.userInfo = res.data
            //         findUserOperation({customId: this.$route.query.id, userId: res.data.id}).then(res => {
            //           this.istrue = res.data ? 2 : 1
            //         })
            //       })
            //     // }
            //   } else {
            //     this.istrue = 1;
            //   }
            // },

            whetherSignUp() {
                findUserOperation({
                    customId: this.$route.query.id,
                    userId: this.C2CUserInfo.id,
                }).then((res) => {
                    this.istrue = res.data
                    if (this.istrue) {
                        // 您已报名该活动 9100105
                        this.text_variables = this.$t('9100090')
                        posthog.capture('$pageview', {
                            name: '活动报名状态页面',
                            pageId: 'activity_join_status_page',
                            activity_id: this.config.customId,
                            activity_status: 'repeat_join',
                        });
                    } else {
                        // 报名成功！
                        this.signUpNow()
                        this.text_variables = this.$t('300355') + ' !'
                        posthog.capture('$pageview', {
                            name: '活动报名状态页面',
                            pageId: 'activity_join_status_page',
                            activity_id: this.config.customId,
                            activity_status: 'success',
                        });
                    }

                })
            },
            signUpNow() {
                if (!this.token) {
                    if (this.isWebViewVar == 'h5') {
                        this.$router.push('/login?historyBack=' + window.encodeURIComponent('/registration?id=' + this.config.customId))
                    } else {
                        this.$jsBridge.callHandler(
                            this.$jsBridgeCmd.appLogin,
                            {
                                code: 200,
                                type: 'login',
                            },
                            (data) => { }
                        )
                    }
                } else {
                    application({
                        customId: this.$route.query.id,
                        userId: this.C2CUserInfo.id,
                    }).then((res) => {
                        // this.whetherSignUp()
                    })
                }
            },
            async getC2CUserInfo() {
                const res = await getUserInfo()
                this.C2CUserInfo = res.data
            },
        },
    }
</script>
<style lang="scss" scoped>
    @import "../../assets/css/variableName";
    @import "../../style/mixin";
    @import "../../assets/css/mixin";

    // @import '../../assets/css/variableName';
    // @import '../../style/mixin';
    // @import '../../assets/uemo-scss/scss/abstracts/_mixins.scss';
    // @import '../../assets/uemo-scss/scss/abstracts/_functions.scss';
    // @import '../../assets/newCss/reset.scss';
    .contract {
        height: 100vh;
        width: 100%;
        overflow: hidden;
        position: fixed !important;
        top: 0;
        left: 0;
        box-sizing: border-box;
        @include background_color("background-color-10");
        .bottomBg {
            position: absolute;
            bottom: 0;
        }
    }
    .main {
        // margin-top: torem(98);
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        span {
            position: absolute;
            top: 50%;
            @include font_color("font-color");
            font-family: Lato;
            font-size: torem(16);
            font-style: normal;
            font-weight: 600;
            line-height: 100%; /* 16px */
            width: torem(300);
            text-align: center;
        }
    }
    .sucImg {
        margin-top: 30%;
        width: torem(269);
        height: torem(250);
    }
    .waitImg {
        // position: absolute;
        // top: 40%;
        margin-top: 240%;
        width: torem(88);
        height: torem(88);
    }
    .endImg {
        margin-top: 10%;
        width: torem(370);
        height: torem(370);
    }
</style>



// WEBPACK FOOTER //
// src/view/contractCompetition/activityIsSignUp.vue